import type { TriviaCategoryKey } from "./catalog";

/** AI-generated badge art in `public/ui/category/` — enamel-badge style, matched set. */
export const CATEGORY_ICON_SRC: Record<TriviaCategoryKey, string> = {
  entertainment: "/ui/category/entertainment.webp",
  art: "/ui/category/art.webp",
  sports: "/ui/category/sports.webp",
  science: "/ui/category/science.webp",
  history: "/ui/category/history.webp",
  geography: "/ui/category/geography.webp",
};

export const CROWN_ICON_SRC = "/ui/category/crown.webp";

export function categoryIconSrc(key: string): string | null {
  return key in CATEGORY_ICON_SRC
    ? CATEGORY_ICON_SRC[key as TriviaCategoryKey]
    : null;
}
